export default __webpack_public_path__ + "static/media/blog.7d4e8de1.jpg";